module.exports = __webpack_public_path__ + "static/media/BLUSH_6510.1a4ca56c.jpg";